export default {
	CURRENCY_TO_COUNTRY: { TW: 'NTD', USA: 'USD' },
	SWITCH: {
		NTD: { title: '美金', currency: 'USD' },
	  USD: { title: '台幣', currency: 'NTD' },
	},
};
